import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../../Services/axiosCommon";
// import FireExtiguisherLayout from "./FireExtinguisherLayout";
import FireSuppressionLayout from "./FireSupressionLayout";

function FeEquipmentView() {
  const { fireSuppressionEditId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axiosInstance
      .get(`/collection-and-returns/${fireSuppressionEditId}`)
      .then((res) => {
        setData(res.data?.data);
      })
      .catch((err) => {
        console.error("Failed to fetch equipment details", err);
      });
  }, [fireSuppressionEditId]);

  return (
    <FireSuppressionLayout BackButtonAccess={true} EditBttonAccess={false}>
      <div className="w-full h-full mt-0.5 px-2">
        <div className="sm:w-[99%] h-[calc(100vh-195px)] bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between z-10">
          <div className="w-full bg-white mt-2 rounded-lg">
            <div className="w-full py-[1%] bg-baseColor-primary flex justify-between rounded-lg">
              <p className="w-[5%] text-center pl-2 text-white text-xs font-medium">S.No</p>
              <p className="w-[10%] text-left text-white text-xs font-medium">Name</p>
              <p className="w-[10%] text-center text-white text-xs font-medium">Brand</p>
              <p className="w-[10%] text-center text-white text-xs font-medium">Model</p>
              <p className="w-[10%] text-center text-white text-xs font-medium">Quantity</p>
              <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
            </div>

            {data?.items?.length > 0 ? (
              data.items.map((item, index) => (
                <div
                  key={index}
                  className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100"
                >
                  <p className="w-[5%] text-center pl-2 text-xs font-medium text-[#111537] py-1">
                    {index + 1}
                  </p>
                  <p className="w-[10%] text-left text-xs font-medium text-[#111537] py-1">{item?.name}</p>
                  <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">{item?.brand}</p>
                  <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">{item?.model}</p>
                  <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">{item?.quantity}</p>
                  <p className="w-[10%] text-center text-xs font-medium text-[#111537] py-1">{item?.unit}</p>
                </div>
              ))
            ) : (
              <div className="text-center text-xs text-gray-500 py-4">
                No equipment items found.
              </div>
            )}
          </div>
        </div>
      </div>
    </FireSuppressionLayout>
  );
}

export default FeEquipmentView;
